import type { CanvasTarget } from '@/workspace/types';

type ActivityCanvas = CanvasTarget & { activityMessageId?: string };
type MessagePart = { type?: string; result?: unknown };

const SUBORDINATE_KINDS = new Set(['skill', 'result', 'agent']);

function containsProducedObject(value: unknown, kind: string, id: string): boolean {
  if (!value || typeof value !== 'object') return false;
  if (Array.isArray(value)) return value.some((item) => containsProducedObject(item, kind, id));
  const record = value as Record<string, unknown>;
  const nested = record[kind];
  if (nested && typeof nested === 'object' && (nested as Record<string, unknown>).id === id)
    return true;
  return Object.values(record).some((item) => containsProducedObject(item, kind, id));
}

/** Pick the one canvas target used by the Activity line click. */
export function activityTargetFor(
  current: CanvasTarget | null | undefined,
  messageId: string,
  parts: readonly MessagePart[],
): CanvasTarget {
  const candidate = current as ActivityCanvas | null | undefined;
  if (
    candidate &&
    SUBORDINATE_KINDS.has(candidate.kind) &&
    (candidate.activityMessageId === messageId ||
      parts.some((part) => containsProducedObject(part.result, candidate.kind!, candidate.id!)))
  ) {
    return {
      ...candidate,
      tab: 'activity',
      activityMessageId: messageId,
    } as unknown as CanvasTarget;
  }
  return { kind: 'activity', id: messageId };
}
